import React from 'react';
import './Loader.css'; // Add your styles here

const Loader = () => {
    return (
        <div className="loader">
            <div className="spinner"></div>
        </div>
    );
};

export default Loader;
